// extracted by mini-css-extract-plugin
export default {"root":"AccordionCard_root__LFyHJ"};